import { Context, Effect, Layer } from 'effect'

export type BrowserPageService = {
  alert: (message: string) => Effect.Effect<void>
  reload: Effect.Effect<void>
}

export class BrowserPage extends Context.Service<BrowserPage, BrowserPageService>()(
  'BrowserPage'
) {}

/** Owns imperative interactions with the current browser page. */
export const browserPageLayer = Layer.succeed(BrowserPage, {
  alert: (message) => Effect.sync(() => globalThis.alert(message)),
  reload: Effect.sync(() => globalThis.location.reload())
})
